import '~/assets/scss/search-results.scss'


import '~/js/modules/tabs';

window.addEventListener('DOMContentLoaded', () => {
  const searchClearBtn = document.querySelector('.js-search-clear');
  const searchInput = document.querySelector('.js-search-input');
  searchInput.focus();
  searchClearBtn.addEventListener('click', (e) => {
    e.preventDefault();
    searchInput.value = '';
    searchInput.focus();
  });
});
